export default __webpack_public_path__ + "static/Invictus International School-bc414349d4ab759af3c4d72e7ba3b3fb.png";